import React from "react";

export const LandingPage: React.FC<any> = () => {
  return <div className="liberty-loader" />;
};
